import script from "./DomainModelQueryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelQueryCard.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelQueryCard.vue?vue&type=style&index=0&id=1f966137&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f966137"]])

export default __exports__